import Vuex from 'vuex'
import IdleVue from 'idle-vue'
import auth_Store from './store/auth'
import LoginComponent from './views/LoginComponent'
import ForgotPasswordComponent from './views/ForgotPasswordComponent'
import ReLoginComponent from './components/ReLoginComponent'
import NewPasswordComponent from './views/NewPasswordComponent'
import TwofactorEdit from './views/TwofactorEditComponent'

import router from '../../router'
import AuthContainer from './views/AuthContainer'
import WelcomeComponent from "./views/WelcomeComponent";

export default {
  install (Vue) {
    Vue.use(Vuex)

    let Store = new Vuex.Store({
      modules: {
        auth_Store
      }
    })

    Vue.component('auth-relogin', ReLoginComponent)

    function isRouteAllowed (rightList) {
      let arr1 = rightList
      let arr2 = Store.getters.getAuthUserPolicies

      let found = false

      for (let i = 0; i < arr1.length; i++) {
        for (let j = 0; j < arr2.length; j++) {
          if (arr1[i].act === arr2[j].act && arr1[i].obj === arr2[j].obj) {
            found = true
            break
          }
        }
      }
      return found
    }

    router.addRoute(
      {
        path: '/auth',
        name: 'Auth',
        component: AuthContainer,
        children: [
          {
            path: 'login',
            name: 'Login',
            component: LoginComponent
          },
          {
            path: 'newPassword/:token?',
            name: 'NewPassword',
            component: NewPasswordComponent,
            props: true,
            meta: {
              requiresAuth: false
            }
          },
          {
            path: 'forgot',
            name: 'ForgotPassword',
            component: ForgotPasswordComponent
          },
          {
            path: 'welcome/:token',
            name: 'Welcome',
            component: WelcomeComponent,
            props: true
          }
        ]
      })
    router.addRoute(
      {
        path: '/twofactor/:onOff?',
        name: 'TwoFactorEdit',
        component: TwofactorEdit,
        props: true,
        meta: {
          requiresAuth: true
        }
      },
    )

    router.beforeEach((to, from, next) => {
      if (to.matched.some(record => record.meta.requiresAuth)) {
        // Load user from session storage

        const user = JSON.parse(window.sessionStorage.getItem(process.env.VUE_APP_BASE_NAME + '-frontend'))
        // get loginstate for user to log out that user if the sessions keys are not present
        const isLoggedIn = Store.getters.isLoggedIn

        // Check user auth
        if (!user) {
          if (isLoggedIn) {
            Store.dispatch('logout')
          }
          next({ path: '/auth/login' })
        } else {
          // wenn nicht Systemadmin und rechteliste vorhanden für notwendige rechtezum anspringen der Route, dann hier rein sonst else next()
          if (!Store.getters.userIsSystemadmin && to.meta && to.meta.rightsList && to.meta.rightsList.length > 0) {
            //prüfen, ob man route anspringen kann, wenn nicht, wird man zu seiner account seite geleitet
            if (isRouteAllowed(to.meta.rightsList)) {
              next()
            } else {
              next({ path: '/account' })
            }
          } else {
            if (Store.getters.userIsSystemadmin && to.meta.redirectRoot && to.meta.redirectRoot.to && to.meta.redirectRoot.from === to.path) {
              next({ path: to.meta.redirectRoot.to })
            } else {
              next()
            }
          }
        }
      } else {
        next()
      }
    })

    const eventsHub = new Vue()

    Vue.use(IdleVue, {
      eventEmitter: eventsHub,
      idleTime: 5000,
      startAtIdle: true
    })

    new Vue({
      onIdle () {
        Store.dispatch('setIdle')
      },
      onActive () {
        Store.dispatch('setActive')
      },
      created () {
        Store.dispatch('initAuth')
      }
    })

    Vue.mixin({
      created () {
      },
      computed: {
        authStore () {
          return Store
        },
        authRouter () {
          return router
        },
        idleStatus () {
          return Store.getters.idleStatus
        },
        repeatCounterTime () {
          return Store.getters.repeatCounterTime
        }
      },
      methods: {
        logout () {
          Store.dispatch('logout')
        },
        showHTMLByRight (right) {
          let authUser = Store.getters.getAuthUserData

          if (!right || !authUser) {
            return true
          }

          if (typeof right.is_system === 'boolean') {
            if (typeof authUser.user.is_system === 'boolean') {
              return right.is_system && authUser.user.is_system
            } else if (right.is_system) {
              return false
            }
          }

          let perms = authUser.routes // acl.perm
          let found = false

          for (let i = 0; i < perms.length; i++) {
            if (perms[i].route === right.obj && perms[i].method === right.act) {
              found = true
              break
            }
          }

          return found
        },
        getUser () {
          if (Store.getters.isLoggedIn === true) {
            return Object.assign({}, Store.getters.getAuthUserData.user)
          }

          return {}
        },
        getUserAcl () {
          if (Store.getters.isLoggedIn === true) {
            return Object.assign({}, Store.getters.getAuthUserData)
          }

          return {}
        },
        getUserLocationType () {
          if (Store.getters.isLoggedIn === true) {
            return Store.getters.getAuthUserData.user.location_type
          }

          return ''
        },
        getUserLocationName () {
          if (Store.getters.isLoggedIn === true) {
            return Store.getters.getAuthUserData.user.location_name
          }

          return ''
        },
        getUserCancerRegisterDetails () {
          if (Store.getters.isLoggedIn === true) {
            return Object.assign({}, Store.getters.getAuthUserData.user).cancer_form_details || {}
          }

          return {}
        }
      }
    })
  }
}
